import React from 'react';

import { useEditor } from '../../hooks';
import { HeaderButton } from './HeaderButton';

export function HeaderTogglePreview(): React.ReactElement {
  const { state, setState } = useEditor();
  return (
    <HeaderButton
      isActive={state.displayMode === 'view'}
      onClick={() => setState((state) => ({
        ...state,
        displayMode: state.displayMode === 'view' ? 'edit' : 'view',
      }))}
    >
      미리보기
    </HeaderButton>
  );
}
